import clsx from 'clsx';
import React from 'react';
import { TextCommon } from '../Text/TextCommon';
import styles from './tag.module.css';

type TTagProps = {
    metaText?: string;
    metaVariant?: 'text' | 'tag';
    metaHierarchy?: 'primary' | 'secondary' | 'inverted';
    size?: 'default' | 'small';
    disabled?: boolean;
};

const getTagVariant = (props: TTagProps) => {
    return props.metaVariant === 'tag' ? 'tag' : 'main';
};
const getTagColor = (props: TTagProps) => {
    if (props.metaVariant === 'tag') {
        if (props.metaHierarchy === 'inverted') {
            return props.disabled ? 'purple_40_tr' : 'purple_100';
        }
        return props.disabled ? 'white_40_tr_base' : 'white_base';
    }
    if (props.metaHierarchy === 'secondary') {
        return props.disabled ? 'grey_40_lc' : 'grey_72_lc';
    }
    return props.disabled ? 'grey_40_lc' : 'black';
};

export const Tag = (props: TTagProps) => {
    const isTagVariant = props.metaVariant === 'tag';
    const isTagSecondary = props.metaVariant === 'tag' && props.metaHierarchy === 'secondary';
    const isTagInverted = props.metaVariant === 'tag' && props.metaHierarchy === 'inverted';

    const tagClass = () => {
        if (isTagVariant) {
            return props.size === 'small' ? styles.tagSmall : styles.tagDefault;
        }
        return null;
    };

    return (
        <span
            className={clsx(
                styles.tagContainer,
                tagClass(),
                isTagVariant && styles.bgTag,
                isTagSecondary && styles.bgTagSecondary,
                isTagInverted && styles.bgTagInverted,
                props.disabled && styles.bgTagDisabled,
            )}
        >
            <TextCommon isWidget={false} content={props.metaText} options={{ variant: getTagVariant(props), textColor: getTagColor(props) }} />
        </span>
    );
};
